import $ from 'jquery';
import './news/loadMore';
import './powermail/summary';

// Add own JavaScript files here.
import './base/addTableWrapper';
import './powermail/isValidCheck';
window.jQuery = $;
window.$ = $;
// import './powermail/checkboxGroup';